<template>
    <section class="section-padding" id="skeniraj-i-plati">
        <h2 class="text-center">Skeniraj i plati</h2>

        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-4"
        >
            <p class="max-w-sm pt-2 pb-1 py-md-3 py-lg-5">
                <strong>
                    Nova aplikacija omogućava plaćanje goriva bez odlaska na
                    kasu, skeniranjem QR koda koji se nalazi kod točionog
                    aparata.
                </strong>
                Prvi korak je da dodaš svoju platnu karticu. Možeš dodati više
                platnih kartica, jednu postaviti kao glavnu, ali prilikom svakog
                plaćanja možeš odabrati karticu kojom želiš da platiš.
                <br /><br />
                Ako koristiš Program lojalnosti sa poenima, prilikom plaćanja
                goriva skeniranjem ostvaruješ poene. Poeni se obračunavaju na
                osnovu nivoa na kom se trenutno nalaziš, kao i vrste i količine
                goriva koje si sipao. Ako imaš aktiviran Program dinarskog
                popusta, cena goriva se prilikom plaćanja skeniranjem umanjuje u
                skladu sa definisanim popustom.
                <br /><br />
                Takođe, prilikom plaćanja
                <strong>
                    možeš izabrati opciju izdavanja gotovinskog računa.
                </strong>
                U tom slučaju je potrebno da prethodno u delu „Moja kompanija”
                uneseš PIB kompanije na osnovu čega se i generiše gotovinski
                račun.
            </p>
            <img
                width="588"
                height="699"
                loading="lazy"
                class="img-fluid max-w-sm"
                src="/img/application/original/scan-and-pay.webp"
                sizes="(min-width: 768px) 768px, 100vw"
                srcset="
                    /img/application/sm/scan-and-pay.webp    384w,
                    /img/application/lg/scan-and-pay.webp    512w,
                    /img/application/3xl/scan-and-pay.webp   768w,
                    /img/application/5xl/scan-and-pay.webp  1024w,
                    /img/application/7xl/scan-and-pay.webp  1280w,
                    /img/application/8xl/scan-and-pay.webp  1536w,
                    /img/application/9xl/scan-and-pay.webp  1920w,
                    /img/application/10xl/scan-and-pay.webp 2560w
                "
                alt="Skeniranje i plaćanje u aplikaciji"
            />
        </div>
    </section>
</template>

<style scoped>
img {
    width: 36.75rem;
}

@media (max-width: 768px) {
    img {
        width: 100%;
    }
}
</style>
